import { AppProgressBar } from 'next-nprogress-bar';

const ProgressBar = () => (
  <AppProgressBar
    color='#ff794d'
    startPosition={0.1}
    stopDelayMs={100}
    height='8px'
  />
);

export default ProgressBar;
